<template lang="pug">
  ._layout_menu
    OfflineCompanion
    GlobalWrapper
      nuxt
</template>

<script>
import OfflineCompanion from '~/components/OfflineCompanion'
import GlobalWrapper from '../components/GlobalWrapper'

export default {
  middleware: ['Authenticated', 'IsOffline', 'IsLocked'],
  components: {
    OfflineCompanion,
    GlobalWrapper,
  },
}
</script>

<style lang="sass">
body
  --bgColor: #EBEBEB
  --iconColor: #FFFFFF
  --iconActiveColor: #30BAE3
  --primaryColor: #232378
  --textColor: #767676
  --textHighlightColor: #232323
  --backgroundSteak: #ffaaa5
  --darkBlueColor: #1A4982
  background-color: var(--bgColor)
  color: var(--textColor)
  font:
    family: 'Montserrat', sans-serif
    size: 16px
._layout_menu
  backgournd-color: #f9f9f9
</style>
